import { FormattedMessage } from 'react-intl';

import { LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import ArrowRight from '@atlaskit/icon/core/arrow-right';
import { Stack, xcss, Flex, Text } from '@atlaskit/primitives';
import { SimpleTag as Tag } from '@atlaskit/tag';

import { TABS } from '../constants';
import { useResourcesPageUIAnalytics } from '../hooks';

import type { ResourceLinkCardProps } from '../types';

const linkResourceCardStyles = xcss({
	minHeight: '156px',
	borderRadius: 'radius.large',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border',
	backgroundColor: 'elevation.surface.overlay',
	paddingBlockStart: 'space.200',
	paddingBlockEnd: 'space.150',
	paddingInline: 'space.150',
});

export const ResourceLinkCard = ({
	id,
	heading,
	description,
	link,
	category,
}: ResourceLinkCardProps) => {
	const { sendResourceLinkClickUIEvent } = useResourcesPageUIAnalytics();
	const mappedCategory = TABS.find((tab) => tab.id === category);

	return (
		<Stack spread="space-between" space="space.200" grow="fill" xcss={linkResourceCardStyles}>
			<Stack space="space.100">
				<Heading size="small">
					<FormattedMessage {...heading} />
				</Heading>
				<Text>
					<FormattedMessage {...description} />
				</Text>
			</Stack>

			<Flex gap="space.200" justifyContent="space-between">
				{mappedCategory && (
					<Tag text={mappedCategory.text.defaultMessage} elemBefore={mappedCategory.tagIcon} />
				)}
				<LinkButton
					testId="card-link"
					appearance="subtle"
					iconAfter={ArrowRight}
					href={link.href}
					target="_blank"
					onClick={() => sendResourceLinkClickUIEvent(id, category)}
				>
					<FormattedMessage {...link.linkText} />
				</LinkButton>
			</Flex>
		</Stack>
	);
};
